<template>
    <el-dialog :title="dialog.title" border :type="dialog.type" :visible.sync="dialogFormVisible" width="60%"
        :before-close="closeAllocateDialog">
        <!-- 查看有效 -->
        <el-form :model="query" @submit.native.prevent>
            <el-row>
                <customer-state v-model="query.active_status" placeholder="请选择客资状态" class="mr10"></customer-state>
                <el-select v-model="query.visit_amount" collapse-tags clearable placeholder="回访次数"
                    class="handle-select mr10 w7rem">
                    <el-option v-for="(n, index) in 8" :key="n" :label="index" :value="index"></el-option>
                </el-select>
                <picker-source :query="query" placeholder="渠道"></picker-source>
                <el-button type="primary" class="btn-search ml8" @click="getTableData">搜索</el-button>
                <!-- <el-button type="primary" icon="el-icon-download" @click="download">导出</el-button> -->
            </el-row>
        </el-form>
        <div>
            <el-table :data="customerData" @selection-change="toggleSelection" style="width: 100%" height="500">
                <el-table-column type="selection"></el-table-column>
                <el-table-column prop="active_status" label="回访状态" width="180">
                    <template slot-scope="scope">
                        {{scope.row && getActiveStauts(scope.row.active_status)}}
                    </template>
                </el-table-column>
                <el-table-column prop="visit_amount" label="回访次数">
                </el-table-column>
                <el-table-column prop="mobile" label="手机号">
                    <template slot-scope="scope">
                        <el-link type="primary" @click="getMemberDetail(scope.row)">{{scope.row.mobile}}</el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="source_text" label="渠道">
                </el-table-column>
                <el-table-column align="right" label="回收客资">
                    <template slot-scope="scope">
                        <el-button type="primary" class="search ml8" size="mini"
                            @click="switchChange(scope.row)">收回</el-button>
                    </template>

                </el-table-column>
            </el-table>
        </div>
        <div class="footer-box">
            <el-link type="text" icon="el-icon-share" class="tool-item" @click.stop="showAllocateDialog">分配客资</el-link>
            <el-link type="text" icon="el-icon-s-claim" class="tool-item"
                @click.stop="getCustomerRecover">全部回收</el-link>
            <el-link type="text" v-if="type=='called'" icon="el-icon-download" class="tool-item"
                @click.stop="calledDownload">已拨打下载</el-link>
            <el-link type="text" v-if="type=='duplicate'" icon="el-icon-download" class="tool-item"
                @click.stop="duplicateDownload">重复客资下载</el-link>
            <div class="pagination" v-if="isPagination">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="pagination.page" :page-sizes="[10, 15, 30, 50, 100, 300, 1000]"
                    :page-size="pagination.limit" layout="total, sizes, prev, pager, next, jumper"
                    :total="pagination.total"></el-pagination>
            </div>
        </div>
        <allocation ref="allocation" :parent="_self"></allocation>
        <member-detail ref="memberDetail" :parent="_self"></member-detail>
    </el-dialog>
</template>

<script>
import customerState from '@/components/picker/state.vue';
import allocation from '@/components/member/allocation.vue';
import memberDetail from '@/components/member/detail.vue';
import dictionary from '@/utils/dictionary';
import pickerSource from "@/components/picker/sourceSearch.vue";
const activeObj = dictionary.getPicker('active_status');
const activeArr = Object.values(activeObj);

import {
    showDrawerPass
} from '@/utils/common.js';
const query = {
    active_status: [], //回访状态
    source_id: '',
    account_city_id: '',
    account_id: '',
    visit_amount: ''
};

export default {
    components: {
        customerState,
        allocation,
        memberDetail,
        pickerSource
    },
    props: {
        parent: {},
    },
    data() {
        return {
            customerData: [],
            dialogFormVisible: false,
            dialog: {
                title: '',
                visible: false,
                type: ''
            },
            detail: "",
            type: "",
            //反映翻页
            pagination: {
                page: 1,
                limit: 15,
                total: 0
            },
            isPagination: {},
            query: Object.assign({}, query), // 搜索条件
            // allocateForm
            allocateForm: {
                ids: [],
                allocateRow: []
            },
        }
    },
    computed: {
        getActiveStauts: function () {
            return (id) => {
                let target = activeArr.find(ele => ele.id == id);
                return target ? target['title'] : '-';
            }
        }
    },
    beforeCreate() {
        this.showDrawerPass = showDrawerPass;
        this.dictionary = dictionary;
    },
    methods: {
        //下载 已拨打
        calledDownload() {
            let _this = this;
            let url = this.axios.defaults.baseURL + '/api/customer.distribution/exportConnectedBom';
            this.doDownload(url)

        },
        duplicateDownload() {
            let _this = this;
            let url = this.axios.defaults.baseURL + '/api/customer.distribution/downloadUploadDuplicate';
            // this.openPostWindow(url, "下载", '', _this.query)
            this.doDownload(url)
        },
        doDownload(url) {
            let _this = this;
            let query = {
                ..._this.query,
                id: _this.detail.id,
            }
            let params = JSON.parse(JSON.stringify(query))
            this.$post(url, params).then(res => {
                let url = window.URL.createObjectURL(new Blob([res]));
                let link = document.createElement('a');
                link.style.display = 'none';
                link.href = url;
                // 使用响应头里的文件名
                link.setAttribute('download', '客资列表.xlsx');
                document.body.appendChild(link);
                link.click();
            })
        },
        openPostWindow(url, name, params) {
            var tempForm = document.createElement('form')
            tempForm.id = 'tempForm1'
            tempForm.method = 'post';
            tempForm.action = url;
            tempForm.target = name;
            var hideToken = document.createElement("input");
            hideToken.type = 'hidden';
            hideToken.name = "token";
            hideToken.value = localStorage.getItem("token");
            tempForm.appendChild(hideToken);
            tempForm.addEventListener("onsubmit", function () {
                openWindow(name)
            });
            document.body.appendChild(tempForm);
            tempForm.submit();
            document.body.removeChild(tempForm);

            return false
        },
        openWindow(name) {
            window.open('about:blank', name,
                'height=400,width=400,top=0,left=0,toolbar =yes,menubar =yes,scrollbars=yes,resizable=yes,location=yes,status=yes'
            )
        },
        closeAllocateDialog() {
            let _this = this;
            _this.dialogFormVisible = false;
        },
        toggleSelection(e) {
            let ids = [];
            let allocateRow = []
            e.forEach((row, key) => {
                ids.push(row.id);
                allocateRow.push(row)
            });

            this.allocateForm.ids = ids;
            this.allocateForm.allocateRow = allocateRow;
        },
        //获取客资详情
        getMemberDetail(row) {
            let _this = this;
            console.log(row)
            if (_this.$refs['memberDetail']) {
                _this.$refs['memberDetail'].showDailCustomerDrawer(row);
            } else {
                _this.$nextTick(function () {
                    _this.$refs['memberDetail'].showDailCustomerDrawer(row);
                })
            }
        },
        //显示分配客资
        showAllocateDialog() {
            let _this = this;
            _this.allocateList = [];
            _this.capitalPeople = []; //分配客资（人）
            if (_this.allocateForm.ids.length == 0) {
                _this.allocateForm.ids = [];
                _this.$message({
                    message: '请选择要分配的客资',
                    type: 'warning'
                });
                return false;
            }
            if (_this.$refs['allocation']) {
                _this.$refs['allocation'].showDialog(_this.allocateForm, _this.query, _this.detail, 'duplicate');
            } else {
                _this.$nextTick(function () {
                    _this.$refs['allocation'].showDialog(_this.allocateForm, _this.query, _this.detail, 'duplicate');
                })
            }
        },
        //全部客资收回
        getCustomerRecover() {
            let _this = this;
            _this.allocateList = [];
            _this.capitalPeople = []; //分配客资（人）
            if (_this.allocateForm.ids.length == 0) {
                _this.allocateForm.ids = [];
                _this.$message({
                    message: '请选择要收回的客资',
                    type: 'warning'
                });
                return false;
            }
            _this.$confirm('此操作将已选数据全收回吗, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let url = '/api/customer.member/delMember';
                let query = {
                    ids: _this.allocateForm.ids
                };
                this.$post(url, query).then(function (response) {
                    if (response.code == 200) {
                        _this.$message({
                            type: 'success',
                            message: '收回成功!'
                        });
                        _this.getTableData();
                        _this.parent.getTableData()
                    }
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });

        },
        // 分页
        handleSizeChange(val) {
            this.pagination.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.pagination.page = val;
            this.getTableData();
        },
        showDrawer(row, type) {
            let _this = this;
            _this.dialogFormVisible = true;
            _this.detail = row;
            _this.type = type;
            _this.query = Object.assign({}, query)
            _this.query.active_status = [];
            _this.pagination.page = 1
            if (type == 'duplicate') {
                _this.dialog.title = "重复客资 ";
                this.getTableData()
            }
            if (type == 'called') {
                _this.dialog.title = "已拨打客资 ";
                this.getTableData()
            }
        },
        switchChange(e) {
            let _this = this;
            _this.$confirm('此操作将这条数据收回吗, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let url = '/api/customer.member/delMember';
                let query = {
                    ids: [e.id]
                };

                _this.$post(url, query).then(function (response) {
                    if (response.code == 200) {
                        _this.$message({
                            type: 'success',
                            message: '收回成功!'
                        });
                        _this.getTableData();
                        _this.parent.getTableData()
                    }
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        getTableData(options) {
            let _this = this;
            let url = '';
            let query = {
                ...this.query,
                id: _this.detail.id
            };
            query['pagination'] = _this.pagination;

            if (_this.type == 'duplicate') {
                url = '/api/customer.distribution/getUploadDuplicate';
            }
            if (_this.type == 'called') {
                url = '/api/customer.distribution/getConnectedBom';
            }

            this.$post(url, query).then(function (response) {
                if (response.code == 200) {
                    _this.customerData = response.data.list;
                    _this.pagination = response.data.pagination;
                    _this.loading = false;
                }
            });
        },
        // 获取重复客资 
        getUploadDuplicate(options) {
            let _this = this;
            _this.loading = true;

        },
        submit() {

        }
    }
}
</script>
<style lang="less" scoped>
/deep/.el-dialog__body {
    margin: 0 20px 10px 20px;
    padding: 0;
    padding-bottom: 20px;
}
.tool-item {
    margin-right: 15px;
}
</style>  